import { render, staticRenderFns } from "./NoneCodeUserEdit.vue?vue&type=template&id=56cbf636&scoped=true&"
import script from "./NoneCodeUserEdit.vue?vue&type=script&lang=js&"
export * from "./NoneCodeUserEdit.vue?vue&type=script&lang=js&"
import style0 from "./NoneCodeUserEdit.vue?vue&type=style&index=0&id=56cbf636&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56cbf636",
  null
  
)

export default component.exports